/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Campaign_Invitation_InvalidInputs */

const en_error_campaign_invitation_invalid = /** @type {(inputs: Error_Campaign_Invitation_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some customers or brands to invite do not exist or are archived.`)
};

/**
* | output |
* | --- |
* | "Some customers or brands to invite do not exist or are archived." |
*
* @param {Error_Campaign_Invitation_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_campaign_invitation_invalid = /** @type {((inputs?: Error_Campaign_Invitation_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Campaign_Invitation_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_campaign_invitation_invalid(inputs)
});